var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import CommonOnePlatFormActions from "@redux/actions/common/commonActions";
export var UPDATE_FIELD = "UPDATE_FIELD";
export var UPDATE_PAYMENT_MODE_TYPE = "UPDATE_PAYMENT_MODE_TYPE";
export var UPDATE_TRANSACTION_VISIBLE = "UPDATE_TRANSACTION_VISIBLE";
export var SET_TRANSACTIONJOURNEY_DATA = "SET_TRANSACTIONJOURNEY_DATA";
export var SET_TRANSACTIONJOURNEY_MODE = "SET_PURCHASE_MODE";
export var SET_TRANSACTIONJOURNEY_FEE = "SET_PURCHASE_FEE";
export var RESET_VALUE = "RESET_VALUE";
export var SET_PAYMENT_SUCCESS = "SET_PAYMENT_SUCCESS";
export var SET_TRANSACTIONJOURNEY_UPLOAD_DECLARTION = "SET_TRANSACTIONJOURNEY_UPLOAD_DECLARTION";
export var SET_TRANSACTIONJOURNEY_DETAILS = "SET_TRANSACTIONJOURNEY_DETAILS";
export var EXPLORE_DIRTY_PRICE = "EXPLORE_DIRTY_PRICE";
export var EXPLORE_VALIDATE_DIRTY_PRICE = "EXPLORE_VALIDATE_DIRTY_PRICE";
export var EXPLORE_VALIDATE_QUANTITY = "EXPLORE_VALIDATE_QUANTITY";
export var EXPLORE_DRAFT_ORDER = "EXPLORE_DRAFT_ORDER";
export var EXPLORE_DRAFT_ORDER_DETAILS = "EXPLORE_DRAFT_ORDER_DETAILS";
export var EXPLORE_PREVIEW_DRAFT_DOCS = "EXPLORE_PREVIEW_DRAFT_DOCS";
export var EXPLORE_DELETED_DRAFT_DOCS = "EXPLORE_DELETED_DRAFT_DOCS";
export var EXPLORE_SAVED_DRAFT_DOCS = "EXPLORE_SAVED_DRAFT_DOCS";
export var EXPLORE_DP_DETAILS = "EXPLORE_DP_DETAILS";
export var UPDATE_DRAFT_ORDERS_REQUEST_PAYLOAD_ID = "UPDATE_DRAFT_ORDERS_REQUEST_PAYLOAD_ID";
export var EXPLORE_RECENT_CLIENT_SEARCH = "EXPLORE_RECENT_CLIENT_SEARCH";
export var EXPLORE_RECENT_CLIENT_SEARCH_SAVE = "EXPLORE_RECENT_CLIENT_SEARCH";
export var EXPLORE_CLIENT_SEARCH = "EXPLORE_CLIENT_SEARCH";
export var UPDATE_CLIENT_DETAILS = "UPDATE_CLIENT_DETAILS";
export var EXPLORE_BANK_DETAILS = "EXPLORE_BANK_DETAILS";
export var EXPLORE_EMP_PARTNER_DETAILS = "EXPLORE_EMP_PARTNER_DETAILS";
export var SAVE_ORDER = "SAVE_ORDER";
export var SAVE_DOCS = "SAVE_DOCS";
export var SAVE_DRAFT_ORDER_DECLARATIONS = "SAVE_DRAFT_ORDER_DECLARATIONS";
export var UPDATE_TRANSACTION_ID = "UPDATE_TRANSACTION_ID";
export var UPDATE_BANK_CODE_DETAILS = "UPDATE_BANK_CODE_DETAILS";
export var UPDATE_SET_UP_FEE = "UPDATE_SET_UP_FEE";
export var UPDATE_ISIN_CLIENT_DETAILS = "UPDATE_ISIN_CLIENT_DETAILS";
export var UPDATE_ISIN_FIXING_DETAILS = "UPDATE_ISIN_FIXING_DETAILS";
export var UPDATE_VALIDATE_SETUPFEE = "UPDATE_VALIDATE_SETUPFEE";
export var UPDATE_CXO_SELETED_CLIENT = "UPDATE_CXO_SELETED_CLIENT";
export var UPDATE_CXO_IS_SELETED_CLIENT = "UPDATE_CXO_IS_SELETED_CLIENT";
var TransactionJourneyActions = /** @class */ (function (_super) {
    __extends(TransactionJourneyActions, _super);
    function TransactionJourneyActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransactionJourneyActions.prototype.updateClientowner = function (req) {
        this.dispatch({
            type: UPDATE_CXO_SELETED_CLIENT,
            payload: { seletedClientOwner: req },
        });
    };
    TransactionJourneyActions.prototype.isChangeClientOwner = function (req) {
        this.dispatch({
            type: UPDATE_CXO_IS_SELETED_CLIENT,
            payload: { isChangeClientOwner: req },
        });
    };
    TransactionJourneyActions.prototype.validateSetUpFees = function (req) {
        this.dispatch({
            type: UPDATE_VALIDATE_SETUPFEE,
            payload: { validateSetUpFees: req },
        });
    };
    TransactionJourneyActions.prototype.fixingDetails = function (req) {
        this.dispatch({
            type: UPDATE_ISIN_FIXING_DETAILS,
            payload: { fixingDetails: req },
        });
    };
    TransactionJourneyActions.prototype.isinClientDetails = function (req) {
        this.dispatch({
            type: UPDATE_ISIN_CLIENT_DETAILS,
            payload: { isinClientDetails: req },
        });
    };
    TransactionJourneyActions.prototype.updateValidSetUpFess = function (isValidSetUpFee) {
        this.dispatch({
            type: UPDATE_SET_UP_FEE,
            payload: { isValidSetUpFee: isValidSetUpFee },
        });
    };
    TransactionJourneyActions.prototype.getBankCode = function (bankCodeDetails) {
        this.dispatch({
            type: UPDATE_BANK_CODE_DETAILS,
            payload: { bankCodeDetails: bankCodeDetails },
        });
    };
    TransactionJourneyActions.prototype.getDraftOrderDeclarations = function (draftOrderDeclarations) {
        this.dispatch({
            type: SAVE_DRAFT_ORDER_DECLARATIONS,
            payload: { draftOrderDeclarations: draftOrderDeclarations },
        });
    };
    TransactionJourneyActions.prototype.saveOrder = function (saveOrderData) {
        this.dispatch({
            type: SAVE_ORDER,
            payload: { saveOrderData: saveOrderData },
        });
    };
    TransactionJourneyActions.prototype.saveDocs = function (req) {
        this.dispatch({
            type: SAVE_DOCS,
            payload: req,
        });
    };
    TransactionJourneyActions.prototype.getEmpPartnerDetails = function (empPartnerDetails) {
        this.dispatch({
            type: EXPLORE_EMP_PARTNER_DETAILS,
            payload: { empPartnerDetails: empPartnerDetails },
        });
    };
    TransactionJourneyActions.prototype.getBankDetails = function (bankDetails) {
        this.dispatch({
            type: EXPLORE_BANK_DETAILS,
            payload: { bankDetails: bankDetails },
        });
    };
    TransactionJourneyActions.prototype.getClientSearch = function (clientDetails) {
        this.dispatch({
            type: EXPLORE_CLIENT_SEARCH,
            payload: { clientDetails: clientDetails },
        });
    };
    TransactionJourneyActions.prototype.getRecentClientSearch = function (recentClientSearch) {
        this.dispatch({
            type: EXPLORE_RECENT_CLIENT_SEARCH,
            payload: { recentClientSearch: recentClientSearch },
        });
    };
    TransactionJourneyActions.prototype.saveRecentClientSearch = function (recentClientSearchSave) {
        this.dispatch({
            type: EXPLORE_RECENT_CLIENT_SEARCH_SAVE,
            payload: { recentClientSearchSave: recentClientSearchSave },
        });
    };
    TransactionJourneyActions.prototype.getDpDetails = function (dpDetails) {
        this.dispatch({
            type: EXPLORE_DP_DETAILS,
            payload: { dpDetails: dpDetails },
        });
    };
    TransactionJourneyActions.prototype.saveDraftOrder = function (draftOrder) {
        this.dispatch({
            type: EXPLORE_DRAFT_ORDER,
            payload: { draftOrder: draftOrder },
        });
    };
    TransactionJourneyActions.prototype.getDraftOrderDetails = function (draftOrderDetails) {
        this.dispatch({
            type: EXPLORE_DRAFT_ORDER_DETAILS,
            payload: { draftOrderDetails: draftOrderDetails },
        });
    };
    TransactionJourneyActions.prototype.previewDraftDocs = function (previewDraftDocs) {
        this.dispatch({
            type: EXPLORE_PREVIEW_DRAFT_DOCS,
            payload: { previewDraftDocs: previewDraftDocs },
        });
    };
    TransactionJourneyActions.prototype.deletedDraftDocs = function (deletedDraftDocs) {
        this.dispatch({
            type: EXPLORE_DELETED_DRAFT_DOCS,
            payload: { deletedDraftDocs: deletedDraftDocs },
        });
    };
    TransactionJourneyActions.prototype.savedDraftDocs = function (savedDraftDocs) {
        this.dispatch({
            type: EXPLORE_SAVED_DRAFT_DOCS,
            payload: { savedDraftDocs: savedDraftDocs },
        });
    };
    TransactionJourneyActions.prototype.getDirtyPriceDetails = function (dirtyPriceDetails) {
        this.dispatch({
            type: EXPLORE_DIRTY_PRICE,
            payload: { dirtyPriceDetails: dirtyPriceDetails },
        });
    };
    TransactionJourneyActions.prototype.validateQuantity = function (validateQuantity) {
        this.dispatch({
            type: EXPLORE_VALIDATE_QUANTITY,
            payload: { validateQuantity: validateQuantity },
        });
    };
    TransactionJourneyActions.prototype.validateDirtyPrice = function (validateDirtyPrice) {
        this.dispatch({
            type: EXPLORE_VALIDATE_DIRTY_PRICE,
            payload: { validateDirtyPrice: validateDirtyPrice },
        });
    };
    TransactionJourneyActions.prototype.resetValue = function () {
        this.dispatch({
            type: RESET_VALUE,
            reducerName: "transactionJourney",
        });
    };
    TransactionJourneyActions.prototype.updateTransactionData = function (req) {
        this.dispatch({
            type: SET_TRANSACTIONJOURNEY_DATA,
            payload: { transactionJourney: req },
        });
    };
    TransactionJourneyActions.prototype.updatePaymentModeValues = function (req) {
        this.dispatch({
            type: SET_TRANSACTIONJOURNEY_MODE,
            payload: { paymentMode: req },
            reducerName: "transactionJourney",
        });
    };
    TransactionJourneyActions.prototype.updateTransactionFeeValueProp = function (req) {
        this.dispatch({
            type: SET_TRANSACTIONJOURNEY_FEE,
            payload: {
                purchaseFee: req,
            },
            reducerName: "transactionJourney",
        });
    };
    TransactionJourneyActions.prototype.updateUploadDeclarationValueProp = function (req) {
        this.dispatch({
            type: SET_TRANSACTIONJOURNEY_UPLOAD_DECLARTION,
            payload: {
                uploadDeclaration: req,
            },
            reducerName: "payment",
        });
    };
    TransactionJourneyActions.prototype.updateTransactionSuccess = function (req) {
        this.dispatch({
            type: SET_PAYMENT_SUCCESS,
            payload: {
                paymentSuccess: req,
            },
        });
    };
    TransactionJourneyActions.prototype.updateTransactionDetails = function (req) {
        this.dispatch({
            type: SET_TRANSACTIONJOURNEY_DETAILS,
            payload: {
                transactionDetails: req,
            },
        });
    };
    TransactionJourneyActions.prototype.updateTransactionVisible = function (transactionVisible) {
        this.dispatch({
            type: UPDATE_TRANSACTION_VISIBLE,
            payload: {
                transactionVisible: transactionVisible,
            },
        });
    };
    TransactionJourneyActions.prototype.updateDraftOrdersRequestPayload = function (draftOrdersRequestPayload) {
        this.dispatch({
            type: UPDATE_DRAFT_ORDERS_REQUEST_PAYLOAD_ID,
            payload: { draftOrdersRequestPayload: draftOrdersRequestPayload },
        });
    };
    TransactionJourneyActions.prototype.updateClientDetails = function (req) {
        this.dispatch({
            type: UPDATE_CLIENT_DETAILS,
            payload: {
                selectedClientDetails: req,
            },
        });
    };
    TransactionJourneyActions.prototype.updateTransactionId = function (req) {
        this.dispatch({
            type: UPDATE_TRANSACTION_ID,
            payload: {
                transactionId: req,
            },
        });
    };
    return TransactionJourneyActions;
}(CommonOnePlatFormActions));
export default TransactionJourneyActions;
